import type { JSX } from 'react'

export const HomeSolidIcon = (): JSX.Element => (
  <use href='#homeSolidIcon' height='100%' width='100%' />
)
